// imports
import EventDispatcher from 'minsky-kit/js/managers/EventDispatcher';

// private statics
const VERSION = '1.0.0';

// class definition
export default class AnalystStorage extends EventDispatcher {
    // constructor
    constructor (args = {}, objectName = 'AnalystStorage') {
        args.debug = args.debug || false;
        // super
        super(args, objectName);
    }

    // methods
    destroy () {

    }

    save(id) {
        const favorites = localStorage.getItem('favorites') ? localStorage.getItem('favorites').split(',') : [];    
        favorites.push(id);
        const favoritesString = favorites.join(',');
        console.log(favoritesString);
        localStorage.setItem('favorites', favoritesString);
    }

    remove(id) {
        const favorites = localStorage.getItem('favorites') ? localStorage.getItem('favorites').split(',') : [];    
        favorites.splice(favorites.indexOf('id'), 1);
        const favoritesString = favorites.join(',');
        localStorage.setItem('favorites', favoritesString);
    }

    hasAnalyst(id) {
        const favorites = localStorage.getItem('favorites') ? localStorage.getItem('favorites').split(',') : [];
        return favorites.indexOf(id) > -1;
    }

    getAnalysts() {
        return localStorage.getItem('favorites') ? localStorage.getItem('favorites').split(',') : [];   
    }

    // getters & setters
    static get version () { return VERSION; }
}

// Utils

// Event handlers
